import type { ReactNode } from "react";
import "@fontsource-variable/inter/wght.css";
import "chart.js/auto";
import "./css/globals.css";
import { TRPCProvider } from "./utils/trpc";

export default function RootLayout({ children }: { children: ReactNode }) {
  return <TRPCProvider>{children}</TRPCProvider>;
}
